import { render, staticRenderFns } from "./room2.vue?vue&type=template&id=30da280a&scoped=true&"
import script from "./room2.vue?vue&type=script&lang=js&"
export * from "./room2.vue?vue&type=script&lang=js&"
import style0 from "./room2.vue?vue&type=style&index=0&id=30da280a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30da280a",
  null
  
)

export default component.exports